import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IS_APP_INITIALIZER } from 'projects/is-ui-kit/src/lib/core/app-initializer/app-initializer.service';
import { IS_INTERCEPTOR } from 'projects/is-ui-kit/src/lib/core/interceptor/interceptor.service';
import { UtilsInitializerModule } from 'projects/is-ui-kit/src/lib/core/utils-initializer/utils-initializer.module';
import { InterceptorModule } from 'projects/is-ui-kit/src/lib/core/interceptor/interceptor.module';
import { LoginModule } from './modules/components/login/login.module';
import { CreateUserComponent } from './modules/components/create-user/create-user.component';
import { isMaterialModule } from 'projects/is-ui-kit/src/lib/is-material';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@NgModule({
  declarations: [AppComponent, CreateUserComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    UtilsInitializerModule,
    InterceptorModule,
    LoginModule,
    ...isMaterialModule,
    TranslateModule,
    NgxMatSelectSearchModule
  ],
  providers: [
    IS_APP_INITIALIZER,
    IS_INTERCEPTOR
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
